// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionFieldsetWrapper_root__6VbHN"};